import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

export const selectAddFunds = get('apps.employer-experience.employeeAddFunds');

export const selectTopUpStatus = createSelector(
  selectAddFunds,
  get('topUpStatus'),
);
